import { AbstractControl, ValidatorFn } from "@angular/forms";

/**
 * Checks the minimum length of a control
 * Returns true if not valid, otherwise returns false
 * @param length The length validation number
 */
export function TrimmedMinLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } => {
        const value: any = control.value;
        if (value != null && value.trim().length < length) {
            return { "trimmedminlength": true };
        } else {
            return null;
        }
    };
}